export enum confidentiality {
  public = 'public',
  confidential = 'confidential'
}

export const confidentialityOptions = {
  [confidentiality.public]: {
    label: 'common.not_confidential',
    icon: 'fa-regular fa-unlock'
  },
  [confidentiality.confidential]: {
    label: 'common.label.confidential',
    icon: 'fa-regular fa-lock'
  }
};
